import styled, { css } from "styled-components";

const KioskCancelOrderStyled = styled.span.attrs(() => ({
  className: "kiosk-cancel",
}))`
  ${({ theme, display }) => {
    const { colors, fonts } = theme;

    return css`
      display: ${display === "flex" ? "flex" : "inline-block"};
      margin-bottom: ${display === "flex" ? "20px" : "0"};
      align-items: center;
      justify-content: center;
      font-family: ${fonts.objectSans};
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: ${colors.primary.neutralDark};
      margin-top: 16px;

      .kiosk-cancel__link-wrapper {
        margin-left: 10px;
      }

      .kiosk-cancel__link {
        color: ${colors.primary.neutralDark};
        text-decoration: underline;
        cursor: pointer;
        transition: color 0.2s ease;
        background: none;
        border: none;
        padding: 0;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
      }

      /* Specific styling for OrderOptions usage */
      &.order-options__kiosk-cancel {
        margin-left: 15px;
      }
    `;
  }}
`;

export default KioskCancelOrderStyled;
